import {
  ProgressClaim,
  ProgressClaimApproval,
  ProgressClaimBrandingTemplate,
  ProgressClaimLineItem,
  ProgressClaimScheduleEntry,
  ProgressClaimSummary,
  ProgressClaimTotals,
  ProgressClaimVariationLine,
} from '../models'

const coverLetterBody = `{{Today's Date}}

{{Superintendent Contact Person Bold}}
{{Superintendent Name Bold}}
{{Superintendent Street Address}}
{{Superintendent City}}
{{Superintendent State/ProvinceSuperintendent Postal Code}}
Australia

Dear {{Superintendent Contact First Name}},

{{Subject Line Bold}}

We have reviewed the claim submitted by {{Contractor}} for the works executed up to {{End of Current Month}}

In our opinion, a fair and reasonable assessment of the total cumulative value of work completed is {{Total Value of Work Executed to Date}} ({{Total Value of Work Executed to Date in Words}}) excluding GST.

The total recommended Scheduled Amount is therefore {{Recommended Scheduled Amount (excluding GST)}} ({{Recommended Scheduled Amount (excluding GST) in Words}}) excluding GST.

The total amount recommended is {{Recommended Payment Schedule - TOTAL Difference Phrase}} the builder's claim. Please see attached our assessment breakdown and schedule of differences.

We have sighted the Statutory Declaration from the builder.

Yours faithfully
Donald Cant Watts Corke (VIC) Pty Ltd

{{Project Director Signature}}
{{Project Director Full Name Bold}}
{{Project Director - Role Bold}}`

const letterheadHtml = `
<div style='display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:12px 10px 4px;border-radius:8px;'>
  <div style='display:flex;align-items:flex-start;min-width:150px;'>
    <img src='{{LogoUrl}}' alt='DCWC logo' style='max-height:132px;width:auto;object-fit:contain;margin-left:-20px;' />
  </div>
  <div style='text-align:right;font-size:11px;color:#1c1c1c;line-height:1.45;min-width:220px;'>
    <div style='font-weight:700;'>{{CompanyName}}</div>
    <div>{{Address}}</div>
    <div>{{Phone}}</div>
    <div>{{Email}}</div>
    <div>{{Website}}</div>
    <div>{{Abn}}</div>
    <div style='margin-top:8px;font-weight:700;color:#f79421;'>REF: {{Reference}}</div>
  </div>
</div>
<div style='height:2px;background:#f79421;margin:6px 0;'></div>`

const footerHtml = `
<div style='border-top:2px solid #f79421;padding:10px 0;font-size:11px;display:flex;justify-content:space-between;align-items:flex-start;gap:8px;flex-wrap:wrap;'>
  <div style='display:flex;flex-direction:column;gap:6px;'>
    <div style='font-weight:700;text-transform:uppercase;'><span style='color:#f79421;'>DIRECTORS</span> · GLENN CORKE · STEVE JOHNSON · DAVID CLIFTON-BROWN · SCOTT WAITE</div>
    <div>{{CompanyName}} · {{Abn}}</div>
    <div style='color:#f79421;font-weight:700;'>Adelaide · Brisbane · Canberra · Darwin · Melbourne · Perth · Sydney · Townsville · Fiji</div>
  </div>
  <div style='text-align:right;white-space:nowrap;'>
    <div style='font-weight:700;color:#666;'>partners for</div>
    <div style='font-weight:800;color:#f79421;font-size:18px;'>excellence</div>
  </div>
</div>`

const coverTemplates: ProgressClaimBrandingTemplate[] = [
  {
    id: 'cover-default',
    templateType: 'cover',
    name: 'Standard Cover Letter',
    companyName: 'Donald Cant Watts Corke (VIC) Pty Ltd',
    address: 'Level 5, 180 Flinders Street, Melbourne VIC 3000',
    phone: '+61 3 9690 2600',
    email: 'melbourne@dcwc.com.au',
    website: 'dcwc.com.au',
    abn: 'ABN 65 005 437 841',
    body: coverLetterBody,
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
  {
    id: 'cover-perth',
    templateType: 'cover',
    name: 'Cover Letter - Perth',
    companyName: 'Donald Cant Watts Corke (WA) Pty Ltd',
    address: 'Level 2, 30 The Esplanade, Perth WA 6000',
    phone: '+61 8 6109 1500',
    email: 'perth@dcwc.com.au',
    website: 'dcwc.com.au',
    body: coverLetterBody,
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
]

const letterheadTemplates: ProgressClaimBrandingTemplate[] = [
  {
    id: 'letterhead-default',
    templateType: 'letterhead',
    name: 'Progress Claim Letterhead',
    companyName: 'Donald Cant Watts Corke (VIC) Pty Ltd',
    address: 'Level 5, 180 Flinders Street, Melbourne VIC 3000',
    phone: '+61 3 9690 2600',
    email: 'melbourne@dcwc.com.au',
    website: 'dcwc.com.au',
    abn: 'ABN 65 005 437 841',
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
  {
    id: 'letterhead-perth',
    templateType: 'letterhead',
    name: 'Progress Claim Letterhead - Perth',
    companyName: 'Donald Cant Watts Corke (WA) Pty Ltd',
    address: 'Level 2, 30 The Esplanade, Perth WA 6000',
    phone: '+61 8 6109 1500',
    email: 'perth@dcwc.com.au',
    website: 'dcwc.com.au',
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
]

const footerTemplates: ProgressClaimBrandingTemplate[] = [
  {
    id: 'footer-default',
    templateType: 'footer',
    name: 'Progress Claim Footer',
    companyName: 'Donald Cant Watts Corke (VIC) Pty Ltd',
    address: 'Level 5, 180 Flinders Street, Melbourne VIC 3000',
    phone: '+61 3 9690 2600',
    email: 'melbourne@dcwc.com.au',
    website: 'dcwc.com.au',
    abn: 'ABN 65 005 437 841',
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
  {
    id: 'footer-perth',
    templateType: 'footer',
    name: 'Progress Claim Footer - Perth',
    companyName: 'Donald Cant Watts Corke (WA) Pty Ltd',
    address: 'Level 2, 30 The Esplanade, Perth WA 6000',
    phone: '+61 8 6109 1500',
    email: 'perth@dcwc.com.au',
    website: 'dcwc.com.au',
    headerHtml: letterheadHtml,
    footerHtml: footerHtml,
  },
]

const contractBreakdown: ProgressClaimLineItem[] = [
  {
    id: 'cb-1',
    itemNumber: 1,
    description: 'Preliminaries',
    tradeAmount: 0,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 501252.86,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 501252.86,
    buildersAmount: 0,
    difference: 0,
    reason: '',
    children: [
      {
        id: 'cb-1-1',
        itemNumber: 1,
        parentId: 'cb-1',
        description: 'Preliminaries Child 1',
        tradeAmount: 0,
        grossPercent: 0,
        grossAmount: 0,
        previousAmount: 65934,
        thisPayment: 0,
        costToComplete: 0,
        percentComplete: 0,
        buildersClaim: 0,
        buildersPrevious: 65934,
        buildersAmount: 0,
        difference: 0,
        reason: '',
      },
    ],
  },
  {
    id: 'cb-2',
    itemNumber: 2,
    description: 'Demolition',
    tradeAmount: 0,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 65934,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 65934,
    buildersAmount: 0,
    difference: 0,
    reason: 'Pending site check',
  },
  {
    id: 'cb-3',
    itemNumber: 3,
    description: 'Groundwork',
    tradeAmount: 0,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 128498,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 128498,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
  {
    id: 'cb-4',
    itemNumber: 4,
    description: 'Concrete',
    tradeAmount: 0,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 548625.88,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 548625.88,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
  {
    id: 'cb-5',
    itemNumber: 5,
    description: 'Steelwork',
    tradeAmount: 0,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 34783.75,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 34783.75,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
]

const variationLines: ProgressClaimVariationLine[] = [
  {
    id: 'var-1',
    variationAssessmentId: 'VAR-001',
    variationNumber: 'VO-001',
    description: 'Additional structural reinforcement for seismic upgrade',
    status: 'approved',
    statusLabel: 'Approved',
    statusTone: 'success',
    approvedAmount: 45000,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 0,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 0,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
  {
    id: 'var-2',
    variationAssessmentId: 'VAR-003',
    variationNumber: 'VO-003',
    description: 'Extended air monitoring period',
    status: 'approved',
    statusLabel: 'Approved',
    statusTone: 'success',
    approvedAmount: 12500,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 9814,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 9814,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
  {
    id: 'var-3',
    variationAssessmentId: 'VAR-004',
    variationNumber: 'VO-004',
    description: 'Additional soil disposal requirements',
    status: 'approved',
    statusLabel: 'Approved',
    statusTone: 'success',
    approvedAmount: 256900,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 9814,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 9814,
    buildersAmount: 0,
    difference: 0,
    reason: '',
  },
  {
    id: 'var-4',
    variationAssessmentId: 'VAR-005',
    variationNumber: 'VO-005',
    description: 'PM fees for project extension',
    status: 'approved',
    statusLabel: 'Approved',
    statusTone: 'success',
    approvedAmount: 10600,
    grossPercent: 0,
    grossAmount: 0,
    previousAmount: 0,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 0,
    buildersClaim: 0,
    buildersPrevious: 0,
    buildersAmount: 0,
    difference: -200000,
    reason: 'Delivery delayed',
  },
  {
    id: 'var-6',
    variationAssessmentId: 'VAR-006',
    variationNumber: 'VO-006',
    description: 'Preliminary cost estimate for foundation works',
    status: 'approved',
    statusLabel: 'Approved',
    statusTone: 'success',
    approvedAmount: 20870,
    grossPercent: 10,
    grossAmount: 0,
    previousAmount: 9814,
    thisPayment: 0,
    costToComplete: 0,
    percentComplete: 10,
    buildersClaim: 0,
    buildersPrevious: 9814,
    buildersAmount: 0,
    difference: -200000,
    reason: 'Site office setup incomplete',
  },
]

const paymentSchedule: ProgressClaimScheduleEntry[] = []

const totals: ProgressClaimTotals = {
  contractSum: 1370000,
  approvedAdjustments: 300000,
  adjustedContractSum: 1670000,
  valueOfWorkExecuted: 950000,
  totalValueOfWorkExecutedToDate: 1508000,
  amountPreviouslyRecommended: 504000,
  recommendedScheduledAmountExGst: 504000,
  retentionMaximumAmount: 0,
  retentionPreviousHeld: 0,
  retentionHeldToDate: 0,
  retentionCurrentDeduction: 0,
  recommendedScheduledAmountAfterRetentionExGst: 504000,
}

const approval: ProgressClaimApproval = {
  preparedBy: {
    name: 'Deverell Newson-King',
    role: 'Senior Quantity Surveyor',
    date: '2025-06-30',
  },
  approvedBy: {
    name: 'Atish Jogia',
    role: 'Associate Director',
    date: '2025-07-07',
  },
}

export const mockProgressClaim: ProgressClaim = {
  meta: {
    id: 'PC-2025-011',
    projectId: 'PROJECT-001',
    projectName: 'Progress Claims - Project 1',
    mode: 'edit',
    revision: 2,
    status: 'approved',
    statusLabel: 'Approved',
    documentStatus: 'approved',
    lastUpdated: '2025-11-28T10:00:00Z',
  },
  details: {
    paymentClaimNumber: 'PC-2024-237',
    paymentRecommendationNumber: 'PR-2024-237',
    contractorPaymentClaimNumber: 'CPC-125',
    referenceSequenceNumber: '001',
    dateOfClaim: '2025-11-12',
    dateOfIssue: '2025-11-13',
    referenceDate: '2025-11-14',
    dateOfValuation: '2025-11-14',
    constructionStartDate: '2025-09-20',
    constructionEndDate: '2026-06-01',
    retentionCapPercentage: null,
    retentionPerClaimPercentage: null,
    documentStatus: 'approved',
  },
  contractBreakdown,
  variations: variationLines,
  paymentSchedule,
  totals,
  approval,
  letterhead: {
    selectedCoverTemplateId: 'cover-default',
    selectedLetterheadTemplateId: 'letterhead-default',
    selectedFooterTemplateId: 'footer-default',
    includeCoverSheet: true,
    notes: 'Use standard cover letter language for initial issue.',
    coverTemplates,
    letterheadTemplates,
    footerTemplates,
  },
}

export const mockProgressClaimSummaries: ProgressClaimSummary[] = [
  {
    id: 'PC-2025-011',
    claimNumber: 'NOV 2025-Claim 11',
    dateOfIssue: '2025-11-15',
    cumulativeCompletedAmount: 8345500,
    recommendedAmount: 0,
    statusLabel: 'Draft',
    statusTone: 'muted',
    status: 'draft',
  },
  {
    id: 'PC-2025-010',
    claimNumber: 'OCT 2025-Claim 10',
    dateOfIssue: '2025-11-03',
    cumulativeCompletedAmount: 8345500,
    recommendedAmount: 8345500,
    statusLabel: 'Approved',
    statusTone: 'success',
    status: 'approved',
  },
  {
    id: 'PC-2025-009',
    claimNumber: 'SEP 2025-Claim 9',
    dateOfIssue: '2025-10-04',
    cumulativeCompletedAmount: 6912861,
    recommendedAmount: 6912861,
    statusLabel: 'Approved',
    statusTone: 'success',
    status: 'approved',
  },
  {
    id: 'PC-2025-008',
    claimNumber: 'AUG 2025-Claim 8',
    dateOfIssue: '2025-09-05',
    cumulativeCompletedAmount: 4830631,
    recommendedAmount: 4830631,
    statusLabel: 'Approved',
    statusTone: 'success',
    status: 'approved',
  },
  {
    id: 'PC-2025-007',
    claimNumber: 'JUL 2025-Claim 7',
    dateOfIssue: '2025-08-04',
    cumulativeCompletedAmount: 3310433,
    recommendedAmount: 3310433,
    statusLabel: 'Approved',
    statusTone: 'success',
    status: 'approved',
  },
]
